export default "__VITE_PUBLIC_ASSET__046238d4__"